module.exports = __webpack_public_path__ + "img/中雪-大雪.ce3d42eb.png";